module.exports = __webpack_public_path__ + "static/media/high_humidity.27a5bb05.svg";